import { render, staticRenderFns } from "./VueContentLoading.vue?vue&type=template&id=bbc5e25e&"
import script from "./VueContentLoading.vue?vue&type=script&lang=js&"
export * from "./VueContentLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports